"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatFunctions_1 = require("../formatFunctions");
/**
 * Sprawdza czy tekst jest podanego formatu
 * @param format format tekstu
 * @param value wartośc do weryfikacji
 */
function check(format, value) {
    return formatFunctions_1.checkFormat(format, value);
}
exports.default = check;
//# sourceMappingURL=check.js.map